export enum WeekdayUrls {
    GetWeekdays= '/api/Weekday/GetWeekdays'
  }
  